import type { HTMLAttributes } from "react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/cn";

export interface ErrorBannerProps extends HTMLAttributes<HTMLDivElement> {
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
  retrying?: boolean;
}

/** A message with Retry; `role="alert"` so it is announced. */
export function ErrorBanner({
  message,
  onRetry,
  retryLabel = "Retry",
  retrying = false,
  className,
  ...props
}: ErrorBannerProps) {
  return (
    <div
      role="alert"
      className={cn(
        "flex flex-wrap items-center justify-between gap-3 rounded-card border border-danger-line bg-danger-bg px-4 py-3 text-danger",
        className,
      )}
      {...props}
    >
      <p className="text-base">{message}</p>
      {onRetry ? (
        <Button variant="secondary" onClick={onRetry} loading={retrying} loadingLabel="Retrying…">
          {retryLabel}
        </Button>
      ) : null}
    </div>
  );
}
